var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#313131"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5C14.8284 15.5 15.5 14.8284 15.5 14C15.5 13.1716 14.8284 12.5 14 12.5C13.1716 12.5 12.5 13.1716 12.5 14C12.5 14.8284 13.1716 15.5 14 15.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4142 15.1379C21.4707 14.7668 21.5 14.3868 21.5 14C21.5 13.6132 21.4707 13.2332 21.4142 12.8621L19.0341 12.5051C18.9295 12.1524 18.7889 11.8152 18.6165 11.4977L20.0469 9.56239C19.8216 9.25586 19.5735 8.96709 19.3052 8.69856L19.3014 8.69484C19.0329 8.4265 18.7441 8.17842 18.4376 7.95309L16.5023 9.38355C16.1848 9.21111 15.8476 9.07047 15.4949 8.96589L15.1379 6.58576C14.7668 6.52929 14.3868 6.5 14 6.5C13.6132 6.5 13.2332 6.52928 12.8621 6.58576L12.5051 8.96589C12.1524 9.07047 11.8152 9.21112 11.4977 9.38355L9.5624 7.95308C9.25802 8.17683 8.97115 8.42301 8.70422 8.68919L8.68919 8.70422C8.42302 8.97114 8.17684 9.25801 7.95309 9.56238L9.38356 11.4977C9.21113 11.8152 9.07048 12.1524 8.9659 12.5051L6.58576 12.8621C6.52929 13.2332 6.5 13.6132 6.5 14C6.5 14.3868 6.52929 14.7668 6.58576 15.1379L8.9659 15.4949C9.07048 15.8476 9.21112 16.1848 9.38355 16.5023L7.95309 18.4376C8.17849 18.7442 8.42665 19.0331 8.69508 19.3017L8.69831 19.3049C8.96691 19.5733 9.25577 19.8215 9.56239 20.0469L11.4977 18.6164C11.8152 18.7889 12.1524 18.9295 12.5051 19.0341L12.8621 21.4142C13.2332 21.4707 13.6132 21.5 14 21.5C14.3868 21.5 14.7668 21.4707 15.1379 21.4142L15.4949 19.0341C15.8476 18.9295 16.1848 18.7889 16.5023 18.6165L18.4376 20.0469C19.0521 19.5952 19.5952 19.0521 20.0469 18.4376L18.6165 16.5023C18.7889 16.1848 18.9295 15.8476 19.0341 15.4949L21.4142 15.1379ZM17 14C17 15.6569 15.6569 17 14 17C12.3431 17 11 15.6569 11 14C11 12.3431 12.3431 11 14 11C15.6569 11 17 12.3431 17 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.fa87a1a65ecb6584cac04232ea5c1ef1.svg";
export { ForwardRef as ReactComponent };